import { isBrowser, browserName } from 'react-device-detect';
import { toLower } from 'lodash';

/**
 * @type {function}
 * @desc A utility function to extract browser information.
 * @example
 * import { browserInfo } from 'utils/browserInfo';
 * const result = browserInfo( ...args );
 */
export const browserInfo = () => {
    return {
        isBrowser: isBrowser,
        browserName: toLower( browserName ),
    };
};
